import axios from 'axios';
import { auth } from './firebase';

const baseURL = import.meta.env.VITE_API_URL !== undefined ? import.meta.env.VITE_API_URL : (import.meta.env.PROD ? '/' : 'http://127.0.0.1:8000');

// Cloud Run direct URL for long-running requests (bypasses Firebase Hosting 60s proxy timeout)
const getCloudRunDirectUrl = () => {
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname.includes('staging')) {
            return 'https://sewa-crm-backend-staging-655420596669.asia-northeast1.run.app';
        }
        if (hostname.includes('sewa-katsu-crm') || hostname.includes('web.app') || hostname.includes('firebaseapp.com')) {
            return 'https://sewa-crm-backend-655420596669.asia-northeast1.run.app';
        }
    }
    return import.meta.env.VITE_CLOUD_RUN_URL || '';
};

const CLOUD_RUN_DIRECT_URL = getCloudRunDirectUrl();

const api = axios.create({
    baseURL,
    timeout: 30000, // 30s for normal requests
});

/**
 * Long-running API client that bypasses Firebase Hosting proxy.
 * Firebase Hosting has a 60s timeout for Cloud Run rewrites.
 * AI analysis (Gemini) can take 90-120s, so we call Cloud Run directly.
 */
export const longRunningApi = axios.create({
    baseURL: CLOUD_RUN_DIRECT_URL || baseURL,
    timeout: 600000, // 10 minutes
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
    try {
        const user = auth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            config.headers.Authorization = `Bearer ${token}`;
        }
    } catch (error) {
        console.error("Auth token error", error);
        // Continue request? Or reject? Likely better to let it fail 401 than hang
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("API Error:", error);
        return Promise.reject(error);
    }
);

// Same interceptors for longRunningApi
longRunningApi.interceptors.request.use(async (config) => {
    try {
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname;
            if (hostname.includes('staging')) {
                config.baseURL = 'https://sewa-crm-backend-staging-655420596669.asia-northeast1.run.app';
            } else if (hostname.includes('sewa-katsu-crm') || hostname.includes('web.app') || hostname.includes('firebaseapp.com')) {
                config.baseURL = 'https://sewa-crm-backend-655420596669.asia-northeast1.run.app';
            }
        }
        const user = auth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            config.headers.Authorization = `Bearer ${token}`;
        }
    } catch (error) {
        console.error("Auth token error", error);
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

longRunningApi.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("API Error (long-running):", error);
        return Promise.reject(error);
    }
);

export default api;
